import React from 'react';
import PropTypes from 'prop-types';

export default function Icon({ type, width, height, className }) {
    return (
        <svg
            className={className}
            height={height}
            viewBox="0 0 20 20"
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            {type === 'play' ? (
                <polygon
                    points="2,2 18,10 2,18"
                    strokeLinejoin="round"
                    strokeWidth="4"
                />
            ) : null}
        </svg>
    );
}

Icon.propTypes = {
    type: PropTypes.oneOf(['play']).isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    className: PropTypes.string,
};
